import React from 'react'

// component
import Content from './Content'
import Header from './Header'
import SideMenu from './SideMenu'
import Notify from './Notify'

// styles
import { WrapMain } from './index.styles'

const Main = () => {
    return (
        <WrapMain>
            <Header className="header" />
            <SideMenu />
            <Content />
            <Notify />
        </WrapMain>
    )
}

export default Main
